export default function IcInfoSvg() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M10 1.875a8.125 8.125 0 1 0 0 16.25 8.125 8.125 0 0 0 0-16.25zM0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0zm8.125-.313a.937.937 0 0 1 .938-.937h1.25a.937.937 0 0 1 .937.938v3.437h.313a.938.938 0 0 1 0 1.875h-2.5a.938.938 0 0 1 0-1.875h.312v-2.5h-.313a.938.938 0 0 1-.937-.938zM10 7.5A1.25 1.25 0 1 0 10 5a1.25 1.25 0 0 0 0 2.5z"
            fill="#0E3D57"/>
    </svg>
  );
}
